export default __webpack_public_path__ + "static/media/elf-03.c974f09c.jpg";